import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AlertService, readJsonFile } from '@selfai-platform/shared';
import { DialogService } from '@selfai-platform/shell';
import { CheckboxModule } from 'primeng/checkbox';
import { FileUploadErrorEvent, FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'selfai-pipeline-variables-upload-form',
  templateUrl: './variables-upload-form.component.html',
  styleUrls: ['./variables-upload-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FileUploadModule, CommonModule, TranslateModule, ToastModule, CheckboxModule, FormsModule],
})
export class VariablesUploadFormComponent {
  private readonly alertService = inject(AlertService);
  private readonly dialogService = inject(DialogService<unknown>);
  private readonly translate = inject(TranslateService);

  protected override = true;

  onError(event: FileUploadErrorEvent): void {
    this.alertService.error(this.translate.instant('workflow.variables.import.error'));
    console.error(event);
  }

  onUpload(event: { files: File[] }): void {
    const { files } = event;

    readJsonFile(files[0]).subscribe({
      next: (data) => {
        this.dialogService.close({ variables: data, override: this.override });
      },
      error: (err: Error) => {
        this.alertService.error(err.message);
      },
    });
  }
}
